import { ApolloError, useQuery, useSubscription } from "@apollo/react-hooks";
import { DocumentNode } from "graphql";
import { MY_TIME_GET_REQUESTS_LIST } from "my-time/graphql/queries";
import { MY_TIME_REQUESTS_SUBSCRIPTION } from "my-time/graphql/subscriptions";

export interface UseMyTimeRequestsParams {
  contractCode: string;
  startDate: string;
  endDate: string;
  requested?: boolean;
  page?: number;
  pageSize?: number;
}

export interface MyTimeRequest {
  // Define the actual shape according to your schema
  id: string;
  date: string;
  startTime: string;
  endTime: string;
  myTimeType: string;
  [key: string]: any;
}

interface MyTimeRequestsQueryData {
  getMyTimeRequestsList: MyTimeRequest[];
}

interface MyTimeRequestsQueryVars {
  contractCode: string;
  startDate: string;
  endDate: string;
  requested?: boolean;
  page?: number;
  pageSize?: number;
}

export interface UseMyTimeRequestsResult {
  data: MyTimeRequest[];
  loading: boolean;
  error?: ApolloError;
  refetch: () => Promise<unknown>;
}

/**
 * Hook to fetch and subscribe to the user's time requests.
 */
export function useMyTimeRequests({
  contractCode,
  startDate,
  endDate,
  requested,
  page,
  pageSize,
}: UseMyTimeRequestsParams): UseMyTimeRequestsResult {
  const { data, loading, error, refetch } = useQuery<
    MyTimeRequestsQueryData,
    MyTimeRequestsQueryVars
  >(MY_TIME_GET_REQUESTS_LIST as DocumentNode, {
    fetchPolicy: "cache-and-network",
    skip: !contractCode,
    variables: {
      contractCode,
      startDate,
      endDate,
      requested,
      page,
      pageSize,
    },
  });

  useSubscription(MY_TIME_REQUESTS_SUBSCRIPTION as DocumentNode, {
    fetchPolicy: "network-only",
    onData: () => {
      refetch();
    },
  });

  return {
    data: data?.getMyTimeRequestsList ?? [],
    loading,
    error,
    refetch,
  };
}

export default useMyTimeRequests;
